//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import styles from './style.module.scss';

const Separator = () => {
    return (
        <div className={styles.container}/>
    );
}
export default Separator;